import { useCallback, useState } from "react";
import { useGetCategoryList } from "../../../hooks/api/useCategory";
import { CATEGORY_STATUS } from "../../Category/enums/categoryEnums";
import { getLeafCategories } from "../../Category/utils/categoryUtils";

/**
 * Gates the add-product modal behind an active category check.
 */
export function useTryOpenAddProduct() {
  const getCategoryList = useGetCategoryList();
  const [addProductOpen, setAddProductOpen] = useState(false);
  const [noCategoryOpen, setNoCategoryOpen] = useState(false);
  const [checkingCategories, setCheckingCategories] = useState(false);

  const tryOpenAddProduct = useCallback(async () => {
    setCheckingCategories(true);
    try {
      const categories = await getCategoryList.mutateAsync({
        status: CATEGORY_STATUS.ACTIVE
      });
      const leafCategories = getLeafCategories(categories ?? []);
      if (leafCategories.length === 0) {
        setNoCategoryOpen(true);
        return;
      }
      setAddProductOpen(true);
    } catch {
      /* Alert is shown by the hook; keep the modal closed */
    } finally {
      setCheckingCategories(false);
    }
  }, [getCategoryList]);

  const closeAddProduct = useCallback(() => setAddProductOpen(false), []);
  const closeNoCategory = useCallback(() => setNoCategoryOpen(false), []);

  return {
    addProductOpen,
    noCategoryOpen,
    checkingCategories,
    tryOpenAddProduct,
    closeAddProduct,
    closeNoCategory
  };
}
